"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../../style/index.scss");
require("./index.scss");
// dependencies
require("../../popup/style");
require("../../selector/style");
require("../../form-value/style");
